var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 100,
    style: {
      enableBackground: "new 0 0 100 114.7"
    },
    viewBox: "0 0 100 114.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_147_7937",
    x: 0,
    y: 0.737305,
    width: 124,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_147_7937"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_147_7937",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_7937",
    x1: 62,
    y1: 25.7373,
    x2: 62,
    y2: 114.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001149"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 50,
    x2: 50,
    y1: 113.842,
    y2: 26.013,
    gradientTransform: "matrix(1 0 0 -1 0 140)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0072ce"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#001149"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_147_7937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9 114c-.7 0-1.4-.3-1.8-.8-.4-.5-.5-1.3-.3-2L24.2 95c.4-1.3 1.7-2.4 3.1-2.4h11.6L41.5 77 24.3 65.7c-3.1-2.1-5.5-6.6-5.5-10.3V52h-2c-2.6 0-5.7-1.3-7.6-3.2l-5.4-5.5C2 41.4.7 38.3.7 35.7V15.9c0-3.9 3.1-7 6.9-7h11.1v-.7c.2-3.7 3.3-6.7 7-6.7h48.2c3.7 0 6.8 2.9 7 6.7v.7H92c3.8 0 7 3.1 7 7v19.8c0 2.6-1.3 5.7-3.1 7.6l-5.4 5.5c-1.8 1.9-5 3.2-7.6 3.2H81v3.4c0 3.7-2.4 8.2-5.5 10.3l-17 11.4 2.6 15.6h11.6c1.3 0 2.7 1 3.1 2.4l4.5 16.1c.2.7.1 1.4-.3 2-.4.5-1.1.8-1.8.8H21.9zm11.5-83.2c-1.4 0-1.8.6-2 1-.1.4-.2 1.1 1 2l7.6 5.6c.9.7 1.4 2.2 1.1 3.3l-2.9 8.9c-.3.8-.2 1.5.1 1.9.2.3.6.5 1 .5s.9-.2 1.5-.6l7.6-5.5c.4-.3 1.1-.5 1.7-.5.7 0 1.3.2 1.7.5l7.6 5.5c.5.4 1 .6 1.4.6.4 0 .7-.2 1-.5.3-.4.3-1.1.1-1.9L59 42.7c-.4-1.1.1-2.6 1.1-3.3l7.6-5.6c1.2-.8 1.1-1.6 1-2-.1-.4-.5-1-2-1h-9.4c-1.2 0-2.4-.9-2.8-2l-3-8.8c-.4-1.3-1.1-1.6-1.5-1.6-.5 0-1.1.3-1.5 1.6l-2.9 8.9c-.3 1.1-1.6 2-2.8 2h-9.4zm47.8 12.6h1.9c.5-.1 1.2-.3 1.5-.6l5.4-5.5c.3-.4.6-1.1.7-1.6V17.4h-9.5v26zM9.3 35.6c.1.5.3 1.2.6 1.6l5.5 5.6c.3.2 1 .5 1.4.6h2v-26H9.3v18.2z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1 2.2c3.3 0 6.1 2.6 6.3 6l.1 1.4h11.8c3.4 0 6.2 2.8 6.2 6.3v19.8c0 2.4-1.2 5.4-2.9 7.1l-5.4 5.5c-1.7 1.7-4.6 2.9-7.1 2.9h-2.7v4.2c0 3.4-2.3 7.7-5.2 9.6L58.5 76.2l-.8.5.2 1 2.4 14.5.2 1.3H72.7c1 0 2.1.8 2.3 1.8l4.5 16.1c.1.5.1 1-.2 1.3-.3.3-.7.5-1.2.5H21.9c-.5 0-.9-.2-1.2-.6-.3-.4-.3-.8-.2-1.3L25 95.2c.3-1 1.3-1.8 2.3-1.8H39.5l.2-1.3 2.4-14.5.2-1-.8-.5-16.8-11c-2.8-1.9-5.2-6.2-5.2-9.7v-4.2h-2.7c-2.4 0-5.4-1.2-7-3l-5.4-5.5C2.7 41 1.5 38 1.5 35.6V15.9c0-3.5 2.8-6.3 6.2-6.3h11.8l.1-1.4c.2-3.3 2.9-6 6.3-6h48.2m6.3 41.9H83.2c.5-.1 1.4-.4 1.8-.7l.1-.1.1-.1 5.4-5.5.1-.1.1-.1c.4-.4.7-1.3.8-1.9V16.7H80.5v27.4m-63.7 0h2.8V16.6H8.5V35.8c.1.6.4 1.4.7 1.9l.1.1.1.1 5.4 5.4.1.1.1.1c.4.2 1.2.6 1.8.6m22.4 10.7c.6 0 1.2-.2 1.9-.7l7.6-5.5c.3-.2.8-.4 1.3-.4s1 .1 1.3.4l7.6 5.5c.7.5 1.3.7 1.9.7.6 0 1.2-.3 1.6-.8.5-.6.5-1.5.2-2.6l-2.9-8.9c-.3-.8.1-2 .8-2.5l7.6-5.5c1.6-1.2 1.4-2.4 1.3-2.8-.1-.5-.7-1.5-2.7-1.5h-9.4c-.8 0-1.8-.7-2.1-1.4L52.3 20c-.6-1.8-1.7-2.1-2.3-2.1-.6 0-1.7.3-2.2 2.1l-2.9 8.9c-.2.8-1.2 1.4-2.1 1.4h-9.4c-2 0-2.5 1.1-2.7 1.5-.2.5-.3 1.7 1.3 2.8l7.6 5.6c.7.5 1 1.7.8 2.5l-2.9 8.9c-.3 1.1-.3 2 .2 2.6.3.3.9.6 1.5.6M74.1.7H25.9c-4.2 0-7.6 3.3-7.8 7.4H7.7C3.4 8.1 0 11.6 0 15.9v19.8c0 2.8 1.4 6.1 3.3 8.1l5.4 5.5c2 2 5.3 3.4 8.1 3.4H18v2.7c0 3.9 2.6 8.7 5.8 10.9l16.7 11.1-2.4 14.5H27.2c-1.7 0-3.3 1.3-3.8 2.9L19 111c-.3.9-.1 1.9.5 2.6.6.7 1.4 1.1 2.4 1.1h56.2c1 0 1.9-.4 2.4-1.1.6-.7.7-1.7.5-2.6l-4.5-16.1c-.5-1.6-2.1-2.9-3.8-2.9H61.8l-2.4-14.5 16.7-11.1c3.3-2.2 5.9-7 5.9-10.9v-2.7h1.2c2.8 0 6.2-1.4 8.1-3.4l5.4-5.5c2-2 3.3-5.3 3.3-8.1V15.9c0-4.3-3.5-7.8-7.7-7.8H81.9C81.7 4 78.2.7 74.1.7zm7.8 41.9V18.2h8v17.4c0 .3-.3.9-.5 1.1L84 42.2c-.2.2-.8.4-1.1.4h-1zm-65 0c-.3 0-.8-.3-1.1-.4l-5.4-5.4c-.2-.2-.4-.8-.5-1.1V18.2h8v24.5h-1v-.1zm22.3 10.7c-.5 0-.6-.5-.3-1.4l2.9-8.9c.5-1.4-.1-3.3-1.3-4.1l-7.6-5.6c-1.2-.9-1-1.7.5-1.7h9.4c1.5 0 3-1.1 3.5-2.5l2.9-8.9c.2-.7.5-1 .8-1 .3 0 .6.4.8 1.1l2.9 8.8c.5 1.4 2 2.5 3.5 2.5h9.4c1.5 0 1.7.8.5 1.7l-7.6 5.6c-1.2.9-1.8 2.7-1.3 4.1l2.9 8.9c.3.9.1 1.4-.3 1.4-.3 0-.6-.1-1-.4l-7.6-5.5c-.6-.4-1.4-.6-2.2-.6-.8 0-1.6.2-2.2.7L40.2 53c-.4.2-.7.3-1 .3z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6b97958de46ce59cc5fb1c984847c601.svg";
export { ForwardRef as ReactComponent };